var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('languages-block',_vm._l((_vm.languages),function(item){return _c('section-button',{key:'lang'+item,staticClass:"lang-btn",class:{active: item == _vm.currentLang},on:{"onClick":function($event){return _vm.setLanguage(item)}}},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }